import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Home: React.FunctionComponent = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/store");
  });

  return <div>Loading...</div>;
};

export default Home;
